import '@paykassma/pay-kit/lib/paykit.css';

import { i18nInit } from '@paykassma/pay-kit';
import { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import fetchAppSettings from 'utils/getAppSettings';

fetchAppSettings()
	.then(({ translations, config }) => {
		// set app config
		window.config = config;

		// set i18n config
		const DEFAULT_LANGUAGE = 'en';
		const currentLanguage =
			localStorage.getItem('language') || DEFAULT_LANGUAGE;

		i18nInit(translations, currentLanguage, DEFAULT_LANGUAGE);

		// Lazy loading is essential to avoid initializing i18n locales outside of React components before the translations are loaded
		const App = lazy(() => import('./App'));

		const root = createRoot(document.getElementById('root') as HTMLElement);

		return root.render(<App />);
	})
	.catch((err) => {
		console.error(err);
	});
